import React from 'react';

const Arrow = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='7' height='10' viewBox='0 0 7 10' {...props}>
    <path
      fill='var(--theme-primary, #810ea9)'
      d='M2.264 4.6L5.91 1.197c.269-.25.269-.658 0-.909-.27-.25-.706-.25-.975 0L.802 4.145c-.27.251-.27.659 0 .91l4.134 3.857c.27.25.706.25.975 0 .269-.251.269-.658 0-.91L2.264 4.6z'
    />
  </svg>
);

export default Arrow;
